/** Русский — основной язык админки. Ключи en.ts обязаны совпадать (проверяет TypeScript). */
export const ru = {
  common: {
    loading: 'Загрузка…',
    empty: 'Ничего нет',
    save: 'Сохранить',
    saved: 'Сохранено',
    cancel: 'Отмена',
    create: 'Создать',
    add: 'Добавить',
    edit: 'Изменить',
    remove: 'Удалить',
    back: 'Назад',
    search: 'Поиск',
    all: 'Все',
    yes: 'Да',
    no: 'Нет',
    none: '— не выбрано —',
    actions: 'Действия',
    status: 'Статус',
    name: 'Название',
    code: 'Код',
    confirm: 'Подтвердить',
    close: 'Закрыть',
    refresh: 'Обновить',
    loadMore: 'Показать ещё',
    optional: 'необязательно',
    language: 'Язык',
    active: 'Активна',
    inactive: 'Выключена',
    demo: 'демо',
    errorTitle: 'Не получилось',
    notFound: 'Страница не найдена',
    noAccess: 'Нет доступа к этому разделу',
  },
  nav: {
    dashboard: 'Обзор',
    catalog: 'Каталог',
    products: 'Товары',
    categories: 'Категории',
    brands: 'Бренды и производители',
    attributes: 'Атрибуты',
    supply: 'Поставки',
    suppliers: 'Поставщики',
    matchQueue: 'Сопоставление',
    pricing: 'Цены',
    priceApprovals: 'Подтверждение цен',
    pricingRules: 'Правила наценки',
    purchaseOrders: 'Закупки',
    warehouse: 'Склад',
    stock: 'Остатки',
    inbound: 'Приёмка',
    fulfillment: 'Сборка и отгрузка',
    stockDocuments: 'Трансферы и инвентаризация',
    sales: 'Продажи',
    returns: 'Возвраты',
    invoices: 'Инвойсы',
    accounting: 'Бухгалтерия',
    orders: 'Заказы',
    customers: 'Клиенты',
    segments: 'Сегменты',
    analytics: 'Аналитика',
    promotions: 'Промо и купоны',
    reviews: 'Отзывы',
    experiments: 'A/B-тесты',
    search: 'Поиск',
    content: 'Страницы',
    seo: 'SEO',
    assistant: 'AI-ассистент',
    aiDrafts: 'Черновики AI',
    ai: 'AI',
    ads: 'Реклама',
    sourcingRules: 'Правила поставщиков',
    settings: 'Настройки',
    staff: 'Сотрудники и роли',
    audit: 'Журнал аудита',
    integrations: 'Интеграции',
    admin: 'Управление',
    logout: 'Выйти',
    interfaceLanguage: 'Язык интерфейса',
  },
  auth: {
    title: 'Вход в админку',
    email: 'Email',
    password: 'Пароль',
    signIn: 'Войти',
    setupTitle: 'Настройка двухфакторной защиты',
    setupHint:
      'Отсканируйте QR-код приложением-аутентификатором (Google Authenticator, 1Password, Authy) и введите 6-значный код.',
    secret: 'Ключ для ручного ввода',
    code: 'Код',
    verifyTitle: 'Код подтверждения',
    verifyHint: 'Введите 6-значный код из приложения или резервный код.',
    recoveryTitle: 'Резервные коды',
    recoveryHint:
      'Сохраните эти коды в надёжном месте. Каждый код срабатывает один раз, если телефон недоступен. Больше они не будут показаны.',
    recoverySaved: 'Я сохранил коды',
    usedRecoveryCode:
      'Использован резервный код. Осталось меньше кодов — при необходимости создайте новые.',
    reauthTitle: 'Подтвердите действие',
    reauthHint: 'Для этого действия нужно ещё раз ввести пароль и код из приложения.',
  },
  dashboard: {
    title: 'Обзор',
    hello: 'Здравствуйте, {{name}}',
    pendingApprovals: 'Цены ждут подтверждения',
    matchQueue: 'Товары поставщиков без сопоставления',
    suppliers: 'Поставщиков',
    open: 'Открыть',
  },
  products: {
    title: 'Товары',
    new: 'Новый товар',
    searchPlaceholder: 'Название, SKU, GTIN или MPN',
    noPackage: 'нет данных об упаковке',
    noPackageHint:
      'Не указаны вес или размер коробки: доставка считается как 1 кг, пакоматы с ячейками не предлагаются. Впишите их в блоке «Упаковка» у варианта товара или добавьте в описание «Размер в упаковке (мм): 620*520*240» и «Вес в упаковке (кг): 5.4».',
    onlyNoPackage: 'Только без данных об упаковке',
    variants: 'Варианты',
    updated: 'Изменён',
    status: { draft: 'Черновик', active: 'Опубликован', archived: 'В архиве' },
    main: 'Основное',
    brand: 'Бренд',
    manufacturer: 'Производитель',
    primaryCategory: 'Основная категория',
    extraCategories: 'Дополнительные категории',
    taxCategory: 'Налоговая категория',
    shippingClass: 'Класс доставки',
    shipping: { standard: 'Обычный', bulky: 'Крупный', oversized: 'Негабарит' },
    warranty: 'Гарантия, мес.',
    translations: 'Тексты',
    translationHint: 'Для публикации нужны тексты на языках всех рынков (lv, lt, et).',
    productName: 'Название',
    slug: 'Адрес (slug)',
    slugHint: 'Пусто — создаётся из названия. При смене старый адрес перенаправляется.',
    shortDescription: 'Краткое описание',
    description: 'Описание',
    seoTitle: 'SEO-заголовок',
    seoDescription: 'SEO-описание',
    variantsTitle: 'Варианты (SKU)',
    sku: 'SKU',
    gtin: 'GTIN (EAN)',
    mpn: 'MPN',
    weight: 'Вес, г',
    package: 'Упаковка (по ней считается доставка)',
    pkg: { weight: 'Вес, кг', length: 'Длина, см', width: 'Ширина, см', height: 'Высота, см' },
    addVariant: 'Добавить вариант',
    variantActive: 'Продаётся',
    attributesTitle: 'Характеристики',
    attributesHint: 'Обязательные характеристики задаются в категории.',
    mediaTitle: 'Изображения',
    uploadImage: 'Загрузить изображение',
    imageHint: 'JPEG, PNG, WebP или AVIF до 20 МБ.',
    role: { main: 'Главное', gallery: 'Галерея', swatch: 'Образец цвета' },
    publish: 'Опубликовать',
    published: 'Товар опубликован',
    archive: 'Снять с продажи',
    archiveConfirm:
      'Товар исчезнет с витрины, его страница будет отвечать «удалён» (410). Можно указать товар-замену — тогда будет перенаправление.',
    replacement: 'ID товара-замены',
    notReady: 'Для публикации не хватает:',
    problem: {
      missing_translation: 'текста на языке {{locale}}',
      no_active_variant: 'активного варианта',
      missing_price: 'цены (рынок {{locale}})',
      missing_manufacturer: 'производителя (GPSR)',
      manufacturer_address_missing: 'адреса производителя (GPSR)',
      missing_required_attribute: 'обязательной характеристики',
      missing_category: 'категории',
    },
    lockedFields: 'Защищено от импорта',
    lockedHint: 'Поля, изменённые вручную, импорт поставщика не перезаписывает.',
    conflict: 'Товар изменил кто-то другой. Обновите страницу и повторите.',
    created: 'Товар создан',
  },
  categories: {
    title: 'Категории',
    new: 'Новая категория',
    parent: 'Родительская',
    root: 'Корень каталога',
    position: 'Порядок',
    move: 'Переместить',
    attributes: 'Характеристики категории',
    required: 'обязательная',
  },
  brands: {
    title: 'Бренды',
    new: 'Новый бренд',
    manufacturers: 'Производители (GPSR)',
    newManufacturer: 'Новый производитель',
    legalName: 'Юридическое название',
    address: 'Адрес',
    line1: 'Улица, дом',
    city: 'Город',
    postalCode: 'Индекс',
    country: 'Страна (код)',
    email: 'Email',
    website: 'Сайт',
    euRp: 'Ответственное лицо в EU',
    euRpHint: 'Нужно, если производитель находится вне EU.',
    noAddress: 'нет адреса',
  },
  attributes: {
    title: 'Атрибуты',
    new: 'Новый атрибут',
    type: 'Тип',
    types: {
      text: 'Текст',
      number: 'Число',
      bool: 'Да/нет',
      enum: 'Список (одно значение)',
      multi_enum: 'Список (несколько)',
      dimension: 'Размер',
    },
    unit: 'Единица',
    filterable: 'Фильтр на витрине',
    searchable: 'Участвует в поиске',
    variantAxis: 'Ось вариантов',
    localized: 'Текст по языкам',
    options: 'Значения списка',
    optionCode: 'Код значения',
    addOption: 'Добавить значение',
    codeHint: 'Латиница, цифры и _. Нельзя изменить после создания.',
  },
  suppliers: {
    title: 'Поставщики',
    new: 'Новый поставщик',
    code: 'Код',
    legalName: 'Юридическое название',
    country: 'Страна',
    currency: 'Валюта',
    vatId: 'VAT номер',
    priority: 'Приоритет',
    leadTime: 'Срок поставки, дн.',
    staleAfter: 'Остатки устаревают через, мин',
    buffer: 'Страховой запас, шт.',
    dropship: 'Дропшиппинг',
    manualOrders: 'Заказы передаются вручную',
    manualOrdersHint:
      'Без e-mail и API: после оплаты заказ поставщику ждёт в «Требует действия», сотрудник передаёт его сам и отмечает «передан».',
    offers: 'Предложений',
    unmatched: 'Без сопоставления',
    sources: 'Источники данных',
    newSource: 'Новый источник',
    sourceName: 'Название источника',
    feedMode: 'Режим файла',
    feed: {
      full: 'Полный (отсутствующие позиции обнуляются)',
      delta: 'Только изменения',
    },
    contentLocale: 'Язык текстов в файле',
    transport: 'Как получаем файл',
    transportType: { upload: 'Загружаем вручную', url: 'Забираем по ссылке' },
    url: 'Ссылка на файл',
    interval: 'Интервал, мин',
    mapping: 'Маппинг полей (JSON)',
    mappingHint:
      'Какие колонки файла соответствуют полям: supplierSku, cost, stockQty обязательны. Пример подставлен по умолчанию.',
    guards: 'Защита от плохого файла',
    maxZeroed: 'Макс. обнулённых остатков, %',
    maxPriceChanged: 'Макс. позиций с сильным изменением цены, %',
    priceThreshold: 'Сильное изменение цены, %',
    upload: 'Загрузить файл',
    uploaded: 'Файл принят, идёт проверка (dry-run)…',
    duplicate: 'Этот файл уже загружался — пропущен.',
    fetchNow: 'Забрать сейчас',
    fetchQueued: 'Загрузка поставлена в очередь',
    runs: 'Журнал импорта',
    lastSuccess: 'Последний успешный',
    lastError: 'Последняя ошибка',
    invalidJson: 'Неверный JSON в маппинге',
    createProducts: 'Создать товары',
    createProductsHint:
      'Артикулы поставщика — по одному в строке (или через запятую). Для каждого создаётся черновик товара: название из файла, бренд, EAN, фото. Цена — по правилам цен. Уже связанные с товаром предложения пропускаются.',
    createProductsSkus: 'Артикулы поставщика',
    createProductsSubmit: 'Создать ({{count}})',
    createProductsQueued:
      'Создаём {{count}} товаров в фоне — через несколько минут они появятся в «Товарах» как черновики.',
    offersTitle: 'Предложения поставщика',
    cost: 'Закупка',
    stock: 'Остаток',
    matched: 'Сопоставлен',
    sourceStatus: { active: 'Работает', degraded: 'Сбои', disabled: 'Выключен' },
  },
  imports: {
    title: 'Импорт',
    run: 'Запуск',
    started: 'Начат',
    finished: 'Завершён',
    job: 'Этап',
    phase: {
      staged: 'Проверен — ждёт применения',
      blocked: 'Остановлен защитой',
      applied: 'Применён',
      failed: 'Ошибка',
      running: 'Идёт обработка…',
    },
    rows: 'Строки',
    valid: 'корректных',
    invalid: 'с ошибками',
    warnings: 'с предупреждениями',
    changes: 'Изменения',
    willCreate: 'новых',
    willUpdate: 'изменённых',
    unchanged: 'без изменений',
    missing: 'Нет в файле (остаток обнулится)',
    zeroed: 'Остаток станет 0',
    bigPriceChanges: 'Сильное изменение цены',
    guardTripped: 'Защита остановила импорт',
    guardHint:
      'Файл выглядит подозрительно. Проверьте его. Если всё верно — примените принудительно (нужно повторное подтверждение).',
    apply: 'Применить',
    applyForced: 'Применить принудительно',
    applyQueued: 'Применение поставлено в очередь. Страница обновится сама.',
    applied: 'Применено',
    appliedStats:
      'создано {{created}}, обновлено {{updated}}, изменений цен {{priceChanges}}, обнулено {{zeroedMissing}}',
    matchedStats: 'сопоставлено по GTIN {{byGtin}}, по MPN {{byMpn}}, в очередь {{queued}}',
    sample: 'Примеры строк',
    row: 'Строка',
    action: 'Действие',
    errors: 'Ошибки',
    data: 'Данные',
    actionName: { create: 'новое', update: 'изменение', error: 'ошибка', unchanged: 'без изм.' },
    status: { running: 'Идёт', succeeded: 'Успешно', failed: 'Ошибка', aborted: 'Прерван' },
  },
  match: {
    title: 'Сопоставление товаров',
    hint: 'Позиции поставщиков, которые не удалось связать автоматически (по GTIN или MPN+бренду).',
    offer: 'Позиция поставщика',
    supplier: 'Поставщик',
    candidates: 'Похожие товары',
    noCandidates: 'Похожих нет',
    link: 'Связать',
    linkById: 'Связать с вариантом (ID)',
    createProduct: 'Создать черновик товара',
    reject: 'Не продаём',
    score: 'сходство {{score}}%',
    resolved: 'Готово',
  },
  prices: {
    title: 'Подтверждение цен',
    hint: 'Изменения цены больше порога ждут решения. Отклонённая цена не предлагается повторно, пока расчёт не изменится.',
    product: 'Товар',
    market: 'Прайс-лист',
    old: 'Было',
    new: 'Станет',
    delta: 'Изменение',
    reason: 'Причина',
    approve: 'Подтвердить',
    reject: 'Отклонить',
    created: 'Когда',
  },
  po: {
    title: 'Закупки',
    hint: 'Заказы поставщикам: dropship создаются автоматически после оплаты, пополнение склада — вручную.',
    number: 'Номер',
    type: 'Тип',
    supplier: 'Поставщик',
    order: 'Заказ',
    status: 'Статус',
    total: 'Сумма',
    created: 'Создан',
    allStatuses: 'Все статусы',
    sku: 'Артикул',
    item: 'Товар',
    qty: 'Кол-во',
    cost: 'Цена закупки',
    shipTo: 'Доставить',
    pickupPoint: 'пакомат',
    supplierRef: 'Номер у поставщика',
    send: 'Отправить поставщику',
    markSent: 'Отметить как переданный',
    confirm: 'Поставщик подтвердил',
    carrier: 'Перевозчик',
    tracking: 'Трек-номер',
    shipped: 'Отправлено',
    cancel: 'Отменить закупку',
    cancelReason: 'Отменено сотрудником',
    sentAt: 'Отправлен',
    types: {
      dropship: 'Dropship',
      replenishment: 'Пополнение склада',
    },
    statuses: {
      draft: 'Черновик',
      sent: 'Отправлен',
      confirmed: 'Подтверждён',
      partially_received: 'Частично получен',
      received: 'Выполнен',
      cancelled: 'Отменён',
    },
  },
  wh: {
    scan: 'Сканируйте или введите артикул/штрихкод',
    add: 'Добавить',
    location: 'Склад',
    allLocations: 'Все склады',
    sku: 'Артикул',
    item: 'Товар',
    code: 'Артикул или штрихкод',
    qty: 'Кол-во',
    onHand: 'На складе',
    reserved: 'Резерв',
    damaged: 'Брак',
    incoming: 'В пути',
    available: 'Доступно',
    when: 'Когда',
    movementType: 'Движение',
    reason: 'Причина',
    searchCode: 'Поиск по артикулу или штрихкоду',
    stockTitle: 'Остатки',
    stockHint: 'Остатки своих складов. Каждое изменение записывается в журнал движений.',
    movementsTitle: 'Журнал движений',
    adjust: 'Корректировка',
    adjustHint:
      'Исправление остатка с обязательной причиной. Брак остаётся на складе, но не продаётся.',
    delta: 'Изменение',
    deltaHint: '+ добавить, − списать',
    markDamaged: 'Это брак (убрать из продажи)',
    purchaseOrder: 'Закупка',
    lines: 'Позиций',
    expectedAt: 'Ожидается',
    inboundTitle: 'Приёмка',
    inboundHint: 'Ожидаемые поставки по подтверждённым закупкам. Сканируйте товар при разгрузке.',
    onlyExpected: 'Только ожидаемые',
    showAll: 'Показать все',
    receiveTitle: 'Приёмка поставки',
    expected: 'Ожидается',
    scanned: 'Отсканировано',
    counted: 'Посчитано',
    completeReceipt: 'Завершить приёмку',
    receivedOk: 'Принято без расхождений.',
    receivedWithDiscrepancies: 'Принято. Расхождений: {{count}} — они сохранены в журнале.',
    notInDelivery: '{{code}} — нет в этой поставке',
    notInOrder: '{{code}} — нет в заказе, уберите из коробки',
    fulfillmentTitle: 'Сборка и отгрузка',
    fulfillmentHint:
      'Оплаченные заказы со своего склада: собрать, упаковать со сканером, наклеить этикетку и передать перевозчику.',
    toPack: 'Собрать и упаковать',
    nothingToPack: 'Нет заказов к сборке.',
    startPicking: 'Начать сборку',
    pack: 'Упаковать',
    packHint: 'Отсканируйте каждый товар. Кнопка станет активной, когда всё совпадёт с заказом.',
    reset: 'Сбросить',
    packed: 'Упаковано',
    toShip: 'Передать перевозчику',
    createLabel: 'Этикетка',
    printLabel: 'Печать этикетки',
    handOver: 'Отправлено',
    documentsTitle: 'Трансферы и инвентаризация',
    documentsHint: 'Перемещение товара между складами и пересчёт остатков.',
    transfers: 'Трансферы',
    newTransfer: 'Новый трансфер',
    route: 'Откуда → куда',
    from: 'Откуда',
    to: 'Куда',
    shipTransfer: 'Отправить',
    receiveAll: 'Принять всё',
    counts: 'Инвентаризация',
    newCount: 'Начать инвентаризацию',
    count: 'Инвентаризация',
    countHint:
      'Сканируйте каждую единицу товара. Разница проводится корректировками при завершении.',
    completeCount: 'Завершить и провести',
    countDone: 'Проведено корректировок: {{count}}.',
    movements: {
      receipt: 'Приход',
      sale: 'Отгрузка',
      reservation: 'Резерв',
      release: 'Снятие резерва',
      adjustment: 'Корректировка',
      damage: 'Брак',
      transfer_out: 'Трансфер (отправка)',
      transfer_in: 'Трансфер (приход)',
      return: 'Возврат',
    },
    inboundStatuses: {
      expected: 'Ожидается',
      in_transit: 'В пути',
      received: 'Принято',
      cancelled: 'Отменено',
    },
    transferStatuses: {
      draft: 'Черновик',
      in_transit: 'В пути',
      received: 'Принят',
      cancelled: 'Отменён',
    },
    countStatuses: {
      draft: 'Черновик',
      in_progress: 'Идёт',
      completed: 'Завершена',
      cancelled: 'Отменена',
    },
  },
  ret: {
    title: 'Возвраты',
    hint: 'Заявки покупателей по праву отказа (14 дней) и другие возвраты: одобрить, принять товар на склад, вернуть деньги.',
    number: 'Номер',
    items: 'Штук',
    kind: 'Тип',
    withdrawal: 'Отказ 14 дней',
    other: 'Другой',
    requestedAt: 'Заявка',
    return: 'Возврат',
    condition: 'Состояние',
    resellable: 'Годный',
    damaged: 'Брак',
    approve: 'Одобрить',
    reject: 'Отклонить',
    rejectReason: 'Причина отказа',
    restockTo: 'Вернуть годное на склад',
    receive: 'Товар получен',
    refundCalc: 'Товары {{items}} + доставка {{shipping}} = {{total}}',
    refundAmount: 'Сумма к возврату, €',
    refundReason: 'Почему меньше',
    refund: 'Вернуть деньги',
    pendingRefunds: 'Ждут ручного возврата денег',
    pendingRefundsHint:
      'Оплата была переводом (или провайдер не ответил): переведите деньги покупателю и подтвердите.',
    confirmRefund: 'Деньги переведены',
    statuses: {
      requested: 'Новая заявка',
      approved: 'Одобрен',
      rejected: 'Отклонён',
      in_transit: 'В пути',
      received: 'Товар получен',
      refunded: 'Деньги возвращены',
      closed: 'Закрыт',
    },
  },
  inv: {
    title: 'Инвойсы',
    hint: 'Счета выпускаются автоматически при оплате, кредит-ноты — при возврате денег. Нумерация без пропусков, изменить выпущенный документ нельзя.',
    number: 'Номер',
    type: 'Тип',
    buyer: 'Покупатель',
    taxMode: 'НДС',
    issuedAt: 'Выпущен',
    allTypes: 'Все документы',
    search: 'Номер документа или заказа',
    types: {
      invoice: 'Счёт',
      credit_note: 'Кредит-нота',
    },
    taxModes: {
      standard: 'Обычный',
      oss: 'OSS',
      reverse_charge: 'Обратное начисление',
      export: 'Экспорт',
    },
  },
  ord: {
    title: 'Заказы',
    hint: 'Все заказы с фильтрами. Откройте заказ, чтобы увидеть оплату, выбор поставщика, отгрузки и историю.',
    number: 'Номер',
    order: 'Заказ',
    created: 'Создан',
    customer: 'Покупатель',
    market: 'Рынок',
    payment: 'Оплата',
    search: 'Номер, email или фамилия',
    allMarkets: 'Все рынки',
    from: 'С даты',
    to: 'По дату',
    found: 'Найдено: {{count}}',
    items: 'Товары',
    vat: 'НДС',
    sourcing: 'Выбор источника',
    noSourcing: 'Решения нет — заказ ещё не оплачен или всё со своего склада.',
    ownStock: 'свой склад',
    manual: 'нужен сотрудник: {{reason}}',
    candidates: 'Кандидаты ({{count}})',
    excluded: 'исключён: {{reason}}',
    score: 'оценка {{score}}',
    timeline: 'История',
    delivery: 'Доставка',
    billing: 'Плательщик',
    customerCard: 'Карточка покупателя',
    payments: 'Оплата',
    refundRow: 'Возврат {{amount}} — {{status}}',
    fulfillment: 'Закупки и отгрузки',
    documents: 'Документы',
    cancel: 'Отменить заказ',
    cancelHint:
      'Резервы снимаются, закупки у поставщиков отменяются, оплаченные деньги возвращаются.',
    refund: 'Вернуть деньги',
    refundHint: 'Возврат без возврата товара (компенсация). Оплачено: {{paid}}.',
    confirmBank: 'Подтвердить перевод',
    confirmBankHint: 'Деньги поступили на счёт — укажите полученную сумму.',
    amount: 'Сумма, €',
    reason: 'Причина',
    markDelivered: 'Доставлено',
    kinds: {
      status: 'статус',
      payment: 'оплата',
      refund: 'возврат',
      shipment: 'доставка',
      purchase: 'закупка',
      email: 'письмо',
      audit: 'действие',
    },
    statuses: {
      NEW: 'Новый',
      PAYMENT_PENDING: 'Ждёт оплату',
      PAID: 'Оплачен',
      RESERVED: 'Зарезервирован',
      PROCESSING: 'Собирается',
      PACKED: 'Упакован',
      SHIPPED: 'Отправлен',
      DELIVERED: 'Доставлен',
      RETURN_REQUESTED: 'Запрошен возврат',
      RETURNED: 'Возвращён',
      REFUNDED: 'Деньги возвращены',
      COMPLETED: 'Завершён',
      CANCELLED: 'Отменён',
    },
    paymentStatuses: {
      unpaid: 'Не оплачен',
      pending: 'Ожидает',
      authorized: 'Авторизован',
      paid: 'Оплачен',
      partially_refunded: 'Частично возвращён',
      refunded: 'Возвращён',
    },
  },
  cust: {
    title: 'Клиенты',
    hint: 'Покупатели и компании: заказы и согласия.',
    search: 'Email или имя',
    name: 'Имя',
    type: 'Тип',
    account: 'Аккаунт',
    orders: 'Заказы',
    spent: 'Покупок на',
    since: 'С',
    marketingYes: 'Рассылка: да',
    marketingNo: 'Рассылка: нет',
    anonymized: 'Данные удалены (GDPR)',
    export: 'Выгрузить данные (JSON)',
    anonymize: 'Анонимизировать',
    anonymizeConfirm: 'Удалить персональные данные клиента безвозвратно?',
    anonymizeYes: 'Да, удалить',
  },
  pricing: {
    title: 'Правила наценки',
    hint: 'Цена = (себестоимость + расходы) × (1 + наценка) + фикс. надбавка → комиссия платёжки → защита минимальной маржи → НДС рынка → округление. Правило «как в рознице поставщика»: цена без НДС = розничная цена поставщика со страницы его товара, дальше — так же. Действует самое конкретное правило (товар > бренд > поставщик > категория > рынок > общее).',
    new: 'Новое правило',
    recalc: 'Пересчитать цены',
    recalcQueued: 'Пересчёт цен запущен — займёт несколько минут.',
    rules: 'Правила',
    noRules: 'Правил нет — цены не рассчитываются. Создайте хотя бы одно общее правило.',
    enable: 'Включить',
    disable: 'Выключить',
    settings: 'Общие настройки',
    settingsHint: 'Действуют на все цены. Сохранение попросит пароль и код и пересчитает все цены.',
    saved: 'Сохранено, пересчёт запущен.',
    paymentFee: 'Комиссия платёжки, %',
    operatingCost: 'Расходы на заказ, €',
    handlingCost: 'Обработка на складе, €',
    defaultMinMargin: 'Мин. маржа по умолчанию, %',
    changeThreshold: 'Подтверждать изменение цены от, %',
    name: 'Название',
    scope: 'Область',
    scopeId: 'ID',
    scopeIdHint: 'ID рынка или товара',
    markup: 'Наценка, %',
    fixed: 'Надбавка, €',
    minMargin: 'Мин. маржа, %',
    minMarginHint: 'Пусто — из общих настроек',
    minMarginShort: 'маржа ≥',
    priority: 'Приоритет',
    rounding: 'Округление',
    scopes: {
      global: 'Общее',
      market: 'Рынок',
      category: 'Категория',
      brand: 'Бренд',
      product: 'Товар',
      supplier: 'Поставщик',
    },
    basis: 'База цены',
    bases: {
      cost: 'Закупка + наценка',
      supplier_retail: 'Как в рознице поставщика',
    },
    basesHint: {
      cost: 'Цена от закупочной цены поставщика.',
      supplier_retail:
        'Цена — как у поставщика в его магазине (раз в сутки со страницы товара; где цена на странице — в маппинге источника, поле page). Наценка не нужна, защита маржи действует.',
    },
    roundings: {
      none: 'Без округления',
      'x.99': 'До ,99',
      'x.95': 'До ,95',
      'x.90': 'До ,90',
      integer: 'До целых евро',
    },
  },
  src: {
    title: 'Правила выбора поставщика',
    hint: 'Свой склад всегда первый. Дальше поставщики оцениваются по весам; действует самое конкретное правило (товар > бренд > категория > рынок > общее).',
    new: 'Новое правило',
    defaults: 'Веса по умолчанию',
    noSplit: 'без дробления',
    name: 'Название',
    scope: 'Где действует',
    scopeId: 'ID объекта',
    scopeIdHint: 'ID рынка, категории, бренда или товара',
    weightsTitle: 'Веса (пусто — по умолчанию)',
    maxLead: 'Макс. срок, дней',
    minMargin: 'Мин. маржа, %',
    allowSplit: 'Можно делить позицию между поставщиками',
    scopes: {
      global: 'Везде',
      market: 'Рынок',
      category: 'Категория',
      brand: 'Бренд',
      product: 'Товар',
    },
    weights: {
      availability: 'Наличие',
      time: 'Срок',
      cost: 'Цена',
      shipping: 'Доставка',
      priority: 'Приоритет',
      margin: 'Маржа',
      reliability: 'Надёжность',
    },
  },
  set: {
    requireManufacturer: 'Для публикации товара нужен производитель с адресом (GPSR)',
    requireManufacturerHint:
      'Регламент ЕС 2023/988, ст. 19. Если выключить — товар можно опубликовать без производителя или без его адреса (решение владельца по совету юриста); в карточке это останется подсказкой.',
    title: 'Настройки',
    hint: 'Реквизиты для инвойсов, возвраты, доставка и оплата.',
    store: 'Магазин',
    sellerName: 'Название продавца',
    regNo: 'Рег. номер',
    vatId: 'PVN номер',
    bank: 'Банковский счёт (IBAN)',
    sellerPhone: 'Телефон для покупателей',
    sellerPhoneHint: 'Показывается в шапке сайта, нажатием можно позвонить. Формат: +371 26283575',
    sellerEmail: 'E-mail для покупателей и в счетах',
    address: 'Адрес',
    addressHint: 'Каждая строка — отдельно',
    saveSeller: 'Сохранить реквизиты',
    returnsAddress: 'Адрес для возвратов (в письме покупателю)',
    holdDays: 'Дней ждём перевод',
    oss: 'НДС для других стран ЕС (OSS)',
    ossHint:
      'Без регистрации в OSS продажи частным лицам в LT/EE идут с НДС Латвии, пока за год меньше 10 000 € без НДС. После порога сайт сам берёт НДС страны покупателя — тогда зарегистрируйтесь в OSS.',
    ossRegistered: 'Фирма зарегистрирована в OSS',
    ossOther: 'Такие же продажи через другие каналы в этом году, € без НДС',
    ossOtherHint: 'Например, wisent.lv: продажи частным лицам в другие страны ЕС.',
    ossPrevious: 'Все такие продажи за прошлый год, € без НДС',
    ossStatus: '{{year}}: магазин {{shop}}, всего {{total}} из {{threshold}}.',
    ossOrigin: 'НДС Латвии',
    ossDestination: 'НДС страны покупателя',
    ossOver:
      'Порог 10 000 € превышен: сайт берёт НДС страны покупателя. Зарегистрируйте фирму в OSS (VID) и отметьте галочку.',
    blocked: 'Не принимать заказы от',
    blockedHint:
      'По одному на строку: адрес (buyer@example.com) или домен (@example.com). Покупатель видит «Не можем принять заказ», без причины.',
    shipping: 'Доставка',
    shippingPricing: 'Цена доставки для покупателя',
    shippingPricingHint:
      'Для тарифов перевозчиков без НДС: тариф + надбавки перевозчика (проценты от тарифа) + наценка магазина + НДС. Надбавки обновляйте по счёту или сайту перевозчика (DPD: dpd.com/lv → Piemaksas; объём: до 50 отправок в месяц +15 %).',
    markup: 'Наценка магазина за посылку, € без НДС',
    courierMin: 'Курьер — не дешевле, € с НДС',
    courierMinHint: 'Если тариф курьера меньше, покупатель платит этот минимум. 0 — без минимума.',
    carrierCol: 'Перевозчик',
    surcharge: {
      fuelSurchargePct: 'Топливо / энергия, %',
      labourSurchargePct: 'Труд, %',
      otherSurchargePct: 'Объём и прочее, %',
    },
    carrier: {
      venipak: 'Venipak',
      omniva: 'Omniva',
      dpd: 'DPD',
      latvijas_pasts: 'Latvijas Pasts',
    },
    tariffNet: 'Цены — тариф перевозчика без НДС.',
    shippingHint:
      'Цены, бесплатная доставка от суммы, сроки. Реальные цены — по договорам с перевозчиками.',
    byWeight: 'по весу ({{count}} ступ.)',
    freeFrom: 'бесплатно от {{amount}}',
    days: 'дн.',
    tariff: 'Тариф',
    tariffHint: 'Одна цена (например 3,99) или строки «до граммов: цена» (например 5000: 3,99)',
    freeFromLabel: 'Бесплатно от суммы, € (пусто — нет)',
    daysMin: 'Срок от, дней',
    daysMax: 'Срок до, дней',
    payments: 'Способы оплаты',
    paymentsHint: 'Какие способы показываются на рынке (провайдер должен быть подключён ключами).',
  },
  staff: {
    title: 'Сотрудники и роли',
    hint: 'Доступы к админке. Изменения требуют повторного подтверждения паролем и кодом.',
    people: 'Сотрудники',
    add: 'Добавить сотрудника',
    roles: 'Роли',
    no2fa: '2FA не настроена',
    disable: 'Отключить',
    enable: 'Включить',
    name: 'Имя',
    created: 'Сотрудник создан. Временный пароль (передайте лично, при входе он настроит 2FA):',
    rolesTitle: 'Роли и права',
    rolesHint: 'Нажмите на роль, чтобы изменить права. Владелец всегда имеет все права.',
    allPermissions: 'все права',
    permissionsCount: 'прав: {{count}}',
  },
  audit: {
    title: 'Журнал аудита',
    hint: 'Все изменения данных сотрудниками и системой. Записи нельзя изменить или удалить.',
    entityType: 'Тип объекта (order, product…)',
    entityId: 'ID объекта',
    more: 'Показать ещё',
  },
  cmdk: {
    open: 'Поиск',
    title: 'Поиск',
    placeholder: 'Номер заказа, артикул, товар или email',
    nothing: 'Ничего не найдено',
  },
  queues: {
    title: 'Требует действия',
    allClear: 'Всё в порядке — ничего не ждёт.',
    manualSourcing: 'Нет поставщика (выбрать вручную)',
    stuckPaid: 'Оплачены, но стоят больше суток',
    stuckWarehouse: 'Не отправлены больше 2 дней',
    returns: 'Возвраты ждут решения',
    refunds: 'Деньги вернуть вручную',
    draftPos: 'Закупки не отправлены поставщику',
    lowStock: 'Заканчиваются на складе',
    integrations: 'Сбои интеграций',
  },
  intg: {
    title: 'Интеграции',
    hint: 'Внешние системы получают события магазина (заказы, документы, возвраты). Сбой — повторы по расписанию; после серии сбоев интеграция приостанавливается и приходит алерт.',
    add: 'Подключить систему',
    empty: 'Пока ничего не подключено. Бухгалтерия получает выгрузки в разделе «Бухгалтерия».',
    lastSuccess: 'Последний успешный обмен',
    deliveries: 'Очередь',
    retryAll: 'Повторить упавшие',
    retry: 'Повторить',
    enable: 'Включить',
    disable: 'Выключить',
    adapter: 'Система',
    name: 'Название',
    keepSecret: 'Оставьте пустым, чтобы не менять ключ',
    events: 'Какие события отправлять',
    statuses: {
      active: 'Работает',
      degraded: 'Сбой',
      disabled: 'Выключена',
    },
    deliveryStatuses: {
      pending: 'Ожидает',
      succeeded: 'Доставлено',
      failed: 'Повтор',
      dead: 'Не доставлено',
    },
    eventNames: {
      orders_status_changed: 'Заказы: смена статуса',
      billing_document_issued: 'Инвойсы и кредит-ноты',
      payments_refund_succeeded: 'Возвраты денег',
      returns_status_changed: 'Возвраты товара',
    },
  },
  acc: {
    title: 'Бухгалтерия',
    hint: 'Выгрузки для бухгалтера и OSS-отчёт. Инвойсы и кредит-ноты выпускаются автоматически.',
    exports: 'Выгрузки за период',
    exportsHint:
      'CSV (разделитель «;», открывается в Excel), Excel или XML. Кредит-ноты — с минусом.',
    datasets: {
      documents: 'Инвойсы и кредит-ноты',
      document_lines: 'Строки документов',
      payments: 'Поступления денег',
      refunds: 'Возвраты денег',
    },
    oss: 'OSS-отчёт (квартал)',
    ossHint:
      'Продажи частным лицам в другие страны ЕС по ставкам страны доставки — для декларации через VID.',
    year: 'Год',
    quarter: 'Квартал',
    ossEmpty: 'В этом квартале OSS-продаж нет.',
    country: 'Страна',
    rate: 'Ставка',
    base: 'Облагаемая сумма',
  },
  ai: {
    title: 'AI',
    hint: 'AI-модули отвечают только по данным магазина. Когда бюджет исчерпан, AI выключается, магазин работает.',
    budget: 'Бюджет',
    budgetHint:
      'Стоимость каждого вызова модели записывается. Лимиты — на календарный месяц и день (UTC).',
    month: 'В этом месяце',
    today: 'сегодня',
    conversations: 'диалогов: {{count}}',
    settings: 'Модули и лимиты',
    settingsHint: 'Модуль работает, только если он включён и на сервере задан ключ API.',
    modules: {
      storefront: 'Ассистент покупателя (витрина)',
      admin: 'Ассистент админки',
      content: 'Черновики контента',
    },
    monthlyBudgetEur: 'Бюджет на месяц, €',
    dailyBudgetEur: 'Бюджет на день, €',
    conversationBudgetEur: 'Один чат покупателя, €',
    assistantModel: 'Модель ассистентов',
    contentModel: 'Модель контента',
    glossary: 'Глоссарий для текстов AI',
    glossaryHint:
      'Термины бренда и товаров, которые пишутся как есть, например «Blanco», «SILGRANIT».',
  },
  exp: {
    title: 'A/B-тесты',
    hint: 'Посетитель с согласием на аналитику всегда видит один и тот же вариант; остальные — контроль. Результат — доля посетителей, оплативших заказ после назначения.',
    new: 'Новый тест',
    empty: 'Тестов пока нет.',
    code: 'Код (его использует витрина, например add_to_cart_text)',
    name: 'Название',
    hypothesis: 'Гипотеза',
    variants: 'Варианты',
    variantsHint:
      'По строке: код вес конфиг-JSON. Первый — «control»; веса в сумме 1. Пример: b 0.5 {"buttonText":{"ru":"Купить сейчас"}}',
    badJson: 'Конфиг варианта — не корректный JSON.',
    running: 'идёт',
    stopped: 'остановлен',
    draft: 'черновик',
    start: 'Запустить',
    stop: 'Остановить',
    since: 'с',
    variant: 'Вариант',
    visitors: 'Посетители',
    orders: 'Оплаченные заказы',
    conversion: 'Конверсия (95 % интервал)',
    uplift: 'к контролю',
    srm: 'Нарушено распределение посетителей (SRM): варианты получают не ту долю трафика. Итогам верить нельзя — проверьте назначение.',
    howToRead:
      'Разница значима при p < 0,05 (✓) и достаточной длительности (минимум полная неделя). Не останавливайте тест в момент, когда он «выглядит хорошо».',
  },
  rev: {
    title: 'Отзывы',
    hint: 'Оставить отзыв может только покупатель, получивший товар. Публикуйте честные отзывы, в том числе негативные; отклоняйте только персональные данные, оскорбления и отзывы не о товаре.',
    status: { pending: 'На проверке', published: 'Опубликованы', rejected: 'Отклонены' },
    empty: 'Здесь пусто.',
    publish: 'Опубликовать',
    reject: 'Отклонить',
  },
  promo: {
    title: 'Промо и купоны',
    hint: 'Без кодов промо действует само; с кодами — только когда покупатель ввёл код. Скидка — от текущей цены, НДС считается после скидки.',
    new: 'Новое промо',
    empty: 'Промо пока нет.',
    name: 'Название',
    type: 'Скидка',
    types: {
      percent: 'Процент',
      fixed: 'Сумма',
      free_shipping: 'Бесплатная доставка',
      tiered: 'Уровни от суммы корзины',
    },
    percent: 'Процент',
    amount: 'Сумма, €',
    tiers: 'Уровни',
    tiersHint: 'По строке: от суммы € : процент, например 200:10',
    minSubtotal: 'Минимальная сумма корзины, €',
    markets: 'Страны (пусто — все)',
    validFrom: 'С',
    validTo: 'По',
    usageLimit: 'Лимит использований',
    codes: 'Коды купонов',
    codesHint: 'По одному в строке; пусто — промо автоматическое.',
    perCustomer: 'Раз на покупателя',
    stackable: 'Суммируется с другими промо',
    active: 'Активно',
    inactive: 'Выключено',
    automatic: 'автоматически',
    used: 'использовано {{count}} раз',
    spent: 'скидок {{amount}}',
  },
  an: {
    title: 'Аналитика',
    hint: 'Продажи, маржа и возвраты — по всем заказам. Посещения и воронка — только по посетителям, разрешившим аналитические cookie.',
    market: 'Страна',
    allMarkets: 'Все страны',
    revenue: 'Выручка',
    withVat: 'с НДС, до возвратов',
    orders: 'Заказы',
    aov: 'Средний чек',
    margin: 'Маржа',
    costCoverage: 'себестоимость известна для {{pct}} строк',
    refunds: 'Возвраты',
    sessions: 'Сессии',
    consentOnly: 'с согласием на аналитику',
    conversion: 'Конверсия',
    customers: 'Покупатели',
    newCustomers: 'новых: {{count}}',
    productViews: 'Просмотры товаров',
    searches: 'Поиски',
    funnel: 'Воронка',
    funnelHint: 'Сессии, дошедшие до каждого шага.',
    steps: {
      session: 'Визит',
      product_view: 'Смотрел товар',
      add_to_cart: 'Положил в корзину',
      begin_checkout: 'Начал оформление',
      purchase: 'Оформил заказ',
    },
    cohorts: 'Ценность покупателя (LTV) по месяцу первой покупки',
    cohortsHint:
      'Выручка на покупателя за вычетом возвратов, нарастающим итогом: M0 — месяц первой покупки.',
    cohort: 'Первая покупка',
    month: 'M{{n}}',
    products: 'Товары',
    productsHint: 'По ночным агрегатам: сегодняшний день добавится следующей ночью.',
    product: 'Товар',
    views: 'Просмотры',
    carts: 'В корзину',
    purchases: 'Заказы',
    viewToPurchase: 'Просмотр → заказ',
    netRevenue: 'Выручка без НДС',
    noProducts: 'За период пока нет данных.',
  },
  drafts: {
    title: 'Черновики AI',
    hint: 'Тексты, которые AI написал по данным товара. Ничего не публикуется без вашего одобрения; перед одобрением текст можно поправить.',
    bulk: 'Заполнить пробелы',
    bulkHint:
      'Черновики для товаров, у которых поле на этом языке пустое. Работает в фоне и останавливается, когда кончается бюджет AI.',
    field: 'Поле',
    language: 'Язык',
    from: 'Переводить с',
    limit: 'Товаров',
    fillGaps: 'Создать черновики',
    queued: 'Поставлено в очередь. Черновики появятся ниже через несколько минут.',
    current: 'Сейчас',
    proposed: 'Предложено',
    approve: 'Одобрить',
    reject: 'Отклонить',
    openProduct: 'Открыть товар',
    empty: 'Здесь пусто.',
    generate: 'Черновики AI',
    translate: 'Перевести с AI',
    created: 'Создано черновиков: {{count}} — проверить',
    skipped: 'Пропущено: {{count}} (числа не из данных или неверный формат).',
    status: { pending: 'На проверке', approved: 'Одобрены', rejected: 'Отклонены' },
    fields: {
      shortDescription: 'Краткое описание',
      description: 'Описание',
      seoTitle: 'SEO-заголовок',
      seoDescription: 'SEO-описание',
      faq: 'FAQ',
      translation: 'Перевод',
    },
  },
  asst: {
    title: 'AI-ассистент',
    hint: 'Спросите о продажах, марже, остатках и поставщиках. Ответы — только по готовым отчётам, всегда с периодом и источником данных.',
    off: 'Ассистент админки выключен. Владелец может включить его в разделе AI.',
    noKey: 'На сервере пока не настроена модель AI.',
    question: 'Ваш вопрос',
    ask: 'Спросить',
    thinking: 'Считаю…',
    data: 'Данные',
    rows: 'строк: {{count}}',
    unverified: 'Проверьте числа — их нет в данных: {{numbers}}',
    examples: {
      topSales: 'Топ-5 товаров за 30 дней',
      margin: 'Маржа по поставщикам за 30 дней',
      runsOut: 'Что закончится на складе за 2 недели?',
      reorder: 'Что дозаказать?',
      prices: 'У каких поставщиков выросли цены?',
    },
  },
  seo: {
    title: 'SEO',
    hint: 'Чего не хватает поисковикам, и редиректы со старых адресов. Sitemap, canonical и разметка строятся автоматически.',
    coverage: 'Заполненность по языкам',
    coverageHint: 'Активные товары и категории с пустыми текстами. Красным — нужно доделать.',
    fillWithAi: 'Заполнить черновиками AI →',
    language: 'Язык',
    products: 'Товары',
    noTranslation: 'Нет перевода',
    noSeoTitle: 'Нет SEO-заголовка',
    noSeoDescription: 'Нет SEO-описания',
    noDescription: 'Нет описания',
    noAlt: 'Картинки без alt',
    categoriesNoText: 'Категории без текста',
    worst: 'Товары с наибольшими пробелами',
    languagesMissing: 'пробелы в {{count}} языках',
    redirects: 'Редиректы',
    redirectsHint:
      'Старые адреса (например, прежнего сайта) → новые. Смена адреса товара перенаправляется автоматически. Пути без префикса сайта: /old-page, а не /lv-lv/old-page.',
    oldPath: 'Старый адрес',
    newPath: 'Новый адрес',
    type: 'Тип',
    moved: '301 — переехало',
    gone: '410 — удалено навсегда',
    search: 'Найти адрес',
  },
  cms: {
    title: 'Страницы',
    hint: 'Тексты страниц витрины: доставка, возврат, юридические. По ним же отвечает ассистент покупателя.',
    formatHint:
      'Простой текст: пустая строка — новый абзац, «## » — заголовок, «- » — пункт списка.',
    market: 'Страна',
    allMarkets: 'Все страны',
    language: 'Язык',
    published: 'Опубликована',
    pageTitle: 'Заголовок',
    body: 'Текст',
    seoTitle: 'SEO-заголовок',
    seoDescription: 'SEO-описание',
    codes: {
      about: 'О нас',
      contact: 'Контакты',
      shipping: 'Доставка',
      returns: 'Возврат',
      payment: 'Оплата',
      warranty: 'Гарантия',
      privacy: 'Политика конфиденциальности',
      terms: 'Условия продажи',
      imprint: 'Реквизиты',
      withdrawal: 'Право на отказ',
      cookies: 'Политика cookie',
    },
  },
  srch: {
    title: 'Поиск',
    hint: 'Синонимы помогают покупателям находить товары своими словами. Отчёт показывает, что искали и не нашли.',
    synonyms: 'Синонимы',
    synonymsHint:
      'Слова, которые в языке значат одно и то же. Односторонний: первое слово находит и остальные, но не наоборот.',
    language: 'Язык',
    terms: 'Слова через запятую',
    termsPlaceholder: 'мойка, раковина',
    oneWay: 'односторонний',
    add: 'Добавить',
    queries: 'Что ищут покупатели',
    queriesHint: 'Запросы без результатов — сигнал: добавьте синоним или недостающие товары.',
    period: 'Период',
    days: '{{count}} дн.',
    searches: 'Поисков',
    zeroRate: 'Без результатов',
    zeroResults: 'Ничего не нашли',
    noZero: 'Все поиски что-то нашли.',
    top: 'Популярные запросы',
    query: 'Запрос',
    results: 'Ср. результатов',
    clicks: 'Клики',
    makeSynonym: 'Синоним…',
  },
  seg: {
    title: 'Сегменты',
    hint: 'Группы клиентов для рассылок и аналитики. Сегменты по правилам пересчитываются каждую ночь (и сразу после сохранения).',
    new: 'Новый сегмент',
    dynamic: 'по правилам',
    manual: 'ручной',
    members: 'клиентов: {{count}}',
    refresh: 'Пересчитать',
    name: 'Название',
    code: 'Код',
    byRules: 'Состав по правилам',
    manualHint: 'Состав ручного сегмента задаётся из карточек клиентов.',
    minOrders: 'Заказов не меньше',
    maxOrders: 'Заказов не больше',
    orderedWithin: 'Покупал за последние N дней',
    notOrderedFor: 'Не покупал больше N дней',
    consent: 'Согласие на рассылку',
    any: 'Не важно',
    preview: 'Сколько клиентов',
    rfm: {
      champions: 'Лучшие',
      loyal: 'Лояльные',
      new: 'Новые',
      at_risk: 'Под угрозой',
      lost: 'Потерянные',
      regular: 'Обычные',
    },
    metrics: 'Покупки',
    ltv: 'Выручка (LTV)',
    aov: 'Средний чек',
    lastOrder: 'Последний заказ',
    revoke: 'Отписать от рассылки',
  },
  ads: {
    title: 'Реклама',
    hint: 'Расходы рекламных кабинетов и что они принесли. Источник заказа — метки рекламы при первом визите (utm, gclid, fbclid).',
    import: 'Загрузить расходы',
    importHint:
      'CSV из Google Ads / Meta: колонки дата, кампания, расход (и по желанию клики, показы, канал, валюта). Повторная загрузка дня перезаписывает его.',
    channel: 'Канал',
    file: 'Файл CSV',
    imported: 'Загружено строк: {{count}}.',
    skipped: 'Пропущены строки: {{lines}}.',
    performance: 'Эффективность каналов',
    performanceHint:
      'CAC — расход на одного нового покупателя, ROAS — выручка (за вычетом возвратов) на 1 € расхода.',
    spend: 'Расход',
    orders: 'Заказы',
    revenue: 'Выручка',
    newCustomers: 'Новые покупатели',
  },
} as const;

type Widen<T> = { [K in keyof T]: T[K] extends string ? string : Widen<T[K]> };
export type Dictionary = Widen<typeof ru>;
